'use client'

import React from "react";
import { motion } from 'framer-motion';
import { Typography, Container } from '@mui/material';

/**
 * data ist eine Liste von Absaetzen.
 *
 * Frueher waren es fuenf feste Felder abschnitt_1..abschnitt_5, weil die
 * Strapi-Tabelle fuenf Spalten hatte - ein sechster Absatz haette eine
 * Datenbankmigration gebraucht. Gerendert wird unveraendert eine Folge von
 * Typography-Absaetzen, jetzt eben so viele wie vorhanden.
 */
export const PhilosopheSection = ({ data }) => {
    const abschnitte = data ?? [];
    return (
        <motion.section
            className="section-large"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.2 }}
        >
            <div className="section-header">
                <div className="section-title">
                    <Typography variant="h3" component="h1" gutterBottom>
                        Philosophie
                    </Typography>
                </div>
            </div>
            <div className="section-body">
                {abschnitte.length > 0 &&
                    <Container maxWidth="full" className="no-padding">
                        {abschnitte.map((abschnitt) => (
                            <React.Fragment key={abschnitt.id}>
                                {abschnitt.titel && <Typography variant="h6" component="h2" gutterBottom>{abschnitt.titel}</Typography>}
                                <Typography variant="body1" mb={2} sx={{ whiteSpace: 'pre-line' }}>
                                    {abschnitt.text}
                                </Typography>
                            </React.Fragment>
                        ))}
                    </Container>}
            </div>
        </motion.section>
    );
};
